export function maskPhone (event, str) {
  const target = event.target
  let position = target.selectionStart

  // remove non-integers i.e. (123) 224-5564 -> 1232245564
  str = str.replace(/[^0-9]/g, '')

  // U.S. (xxx) xxx-xxxx phone numbers
  // (area) prefix-suffix
  const area = str.substr(0, 3)
  const prefix = str.substr(3, 3)
  const suffix = str.substr(6, 4)

  if (area.length === 0) {
    str = ''
  } else {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      position = adjustCaretPositionOnDelete(area, prefix, position)
    } else if (isArrowKey(event)) {
      // do nothing
    } else {
      position = adjustCaretPositionOnEntry(area, prefix, suffix, position)
    }
    str = buildNumber(area, prefix, suffix)
  }

  return {
    str: str,
    e: event,
    pos: position
  }
}

function buildNumber (area, prefix, suffix) {
  return '(' + area + addSpacer(area, 3) + ') ' + prefix + addSpacer(prefix, 3) + '-' + suffix + addSpacer(suffix, 4)
}

function addSpacer (num, max) {
  let str = ''
  for (let i = num.length; i < max; i++) {
    str += '_'
  }
  return str
}

function adjustCaretPositionOnEntry (area, prefix, suffix, position) {
  if (area.length === 1 && position === 1) { // move to account for '('
    position = 2
  } else if (area.length === 3 && prefix.length === 0 && position === 4) { // move to account for ') '
    position = 6
  } else if (prefix.length === 3 && suffix.length === 0 && position === 9) { // move to account for '-'
    position = 10
  }
  return position
}

function adjustCaretPositionOnDelete (area, prefix, position) {
  if (area.length === 3 && position === 6) { // move to account for ') '
    position = 4
  } else if (prefix.length === 3 && position === 10) { // move to account for '-'
    position = 9
  }
  return position
}

function isArrowKey (e) {
  var key = e.key || e.keyCode
  switch (key) {
  case 'ArrowLeft':
    return true
  case 'ArrowRight':
    return true
  default:
    return false
  }
}
